export const TitleValue = ({ title, value }) => {
  return (
    <div className="title-value-box">
      <p className="title">{title}:</p>
      <p className="value">{value ? value : "-"}</p>
    </div>
  );
};
